import { useDropzone } from "react-dropzone";
import classes from "./Dropzone.module.scss";
import { FileArrowUp } from "@phosphor-icons/react";
import clsx from "clsx";

type Props = {
  onDrop: (files: any[]) => any;
  description?: any;
  moddifiers?: string;
  required?: boolean;
  accept?: any;
};

const Dropzone: React.FC<Props> = ({
  onDrop,
  description,
  moddifiers,
  children,
  required,
  accept,
}) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept,
  });

  return (
    <div className={clsx(moddifiers && moddifiers)}>
      <div {...getRootProps()} className={classes.dropzone}>
        <input
          {...getInputProps()}
          required={required}
          style={{ display: "block", position: "absolute", zIndex: -1 }}
          accept={accept}
        />
        {children ? (
          children
        ) : (
          <div className="fs-6">
            <FileArrowUp size={80} />
            <p className="mb-0">Arrastar para aqui os documentos</p>
            <p>
              ou{" "}
              <strong
                className="pointer text-primary"
                style={{ textDecoration: "underline" }}
              >
                escolher ficheiro
              </strong>
            </p>
            {description ? (
              <>
                {typeof description === "string" ? (
                  <p className="text-muted mb-0">{description}</p>
                ) : (
                  description
                )}
              </>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dropzone;
